import React from 'react';
import type { MessageGroupItem } from '../types';
import MessageBubble from './MessageBubble';
import styles from './MessageGroup.module.css';

interface MessageGroupProps {
  group: MessageGroupItem;
}

const MessageGroup: React.FC<MessageGroupProps> = ({ group }) => {
  const isOutgoing = group.messageFlow === 'outgoing';

  return (
    <section className={`${styles.group} ${isOutgoing ? styles['group-outgoing'] : styles['group-incoming']}`}>
      {group.messages.map((message) => (
        <MessageBubble key={message.id} message={message} messageFlow={group.messageFlow} />
      ))}
    </section>
  );
};

export default MessageGroup;
